/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from 'rxjs';
import { requestAuthenticated, Optional, RequestOption, HttpHeaders, HttpQuery, throwIfNullOrUndefined, encodeURI } from '../runtime';
import {
    PageOfRESTItemComposed,
    PageOfRESTOneDriveDocument,
    RESTAsyncRestoreResponse,
    RESTCopyToDocument,
    RESTExceptionInfo,
    RESTOneDriveDocument,
    RESTOperatorRestoreSessionResponse,
    RESTOperatorRestoreToOriginalOneDriveDocuments,
    RESTRestoreToOriginal,
    RESTRestoreToOriginalDocuments,
    RESTSaveDocumentsOptions,
    RESTSaveOneDriveDocumentOptions,
    RESTSendAsMsgOptionsV6,
    RESTSendDocumentsAsMsgOptions,
    RestCopyToDocuments,
} from '../models';

export interface OneDriveDocumentApiOneDriveDocumentCopyToDocumentActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    copyToConfig: RESTCopyToDocument;
}

export interface OneDriveDocumentApiOneDriveDocumentCopyToDocumentActionByVersionIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    versionId: number;
    copyToConfig: RESTCopyToDocument;
}

export interface OneDriveDocumentApiOneDriveDocumentCopyToDocumentsActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    restoreConfig: RestCopyToDocuments;
}

export interface OneDriveDocumentApiOneDriveDocumentGetRequest {
    restoreSessionId: string;
    oneDriveId: string;
    offset: number;
    limit: number;
    parentId?: string;
    includeFolders?: boolean;
}

export interface OneDriveDocumentApiOneDriveDocumentGetByIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
}

export interface OneDriveDocumentApiOneDriveDocumentGetByIdByVersionIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    versionId: number;
}

export interface OneDriveDocumentApiOneDriveDocumentGetVersionsRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    offset: number;
    limit: number;
}

export interface OneDriveDocumentApiOneDriveDocumentOperatorRestoreRequest {
    restoreSessionId: string;
    oneDriveId: string;
    options: RESTOperatorRestoreToOriginalOneDriveDocuments;
}

export interface OneDriveDocumentApiOneDriveDocumentRestoreDocumentActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    restoreConfig: RESTRestoreToOriginal;
}

export interface OneDriveDocumentApiOneDriveDocumentRestoreDocumentActionByVersionIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    versionId: number;
    restoreConfig: RESTRestoreToOriginal;
}

export interface OneDriveDocumentApiOneDriveDocumentRestoreDocumentsActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    restoreConfig: RESTRestoreToOriginalDocuments;
}

export interface OneDriveDocumentApiOneDriveDocumentSaveDocumentActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    saveOptions: RESTSaveOneDriveDocumentOptions;
}

export interface OneDriveDocumentApiOneDriveDocumentSaveDocumentActionByVersionIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    versionId: number;
    saveOptions: RESTSaveOneDriveDocumentOptions;
}

export interface OneDriveDocumentApiOneDriveDocumentSaveDocumentsActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    saveDocuments: RESTSaveDocumentsOptions;
}

export interface OneDriveDocumentApiOneDriveDocumentSendDocumentActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    options: RESTSendAsMsgOptionsV6;
}

export interface OneDriveDocumentApiOneDriveDocumentSendDocumentActionByVersionIdRequest {
    restoreSessionId: string;
    oneDriveId: string;
    documentId: string;
    versionId: number;
    options: RESTSendAsMsgOptionsV6;
}

export interface OneDriveDocumentApiOneDriveDocumentSendDocumentsActionRequest {
    restoreSessionId: string;
    oneDriveId: string;
    options: RESTSendDocumentsAsMsgOptions;
}

/**
 * no description
 */
export const oneDriveDocumentApi = ({

    /**
     * Copies a backed-up OneDrive document with the specified ID to another location in Microsoft OneDrive.
     * Copy OneDrive Document
     */
    oneDriveDocumentCopyToDocumentAction: ({ restoreSessionId, oneDriveId, documentId, copyToConfig }: OneDriveDocumentApiOneDriveDocumentCopyToDocumentActionRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentCopyToDocumentAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentCopyToDocumentAction');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentCopyToDocumentAction');
        throwIfNullOrUndefined(copyToConfig, 'copyToConfig', 'oneDriveDocumentCopyToDocumentAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/copyTo'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'POST',
            headers,
            body: copyToConfig,
        }, option);
    },

    /**
     * Copies a specific version of a backed-up OneDrive document to another location in Microsoft OneDrive.
     * Copy Version of OneDrive Document
     */
    oneDriveDocumentCopyToDocumentActionByVersionId: ({ restoreSessionId, oneDriveId, documentId, versionId, copyToConfig }: OneDriveDocumentApiOneDriveDocumentCopyToDocumentActionByVersionIdRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentCopyToDocumentActionByVersionId');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentCopyToDocumentActionByVersionId');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentCopyToDocumentActionByVersionId');
        throwIfNullOrUndefined(versionId, 'versionId', 'oneDriveDocumentCopyToDocumentActionByVersionId');
        throwIfNullOrUndefined(copyToConfig, 'copyToConfig', 'oneDriveDocumentCopyToDocumentActionByVersionId');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions/{versionId}/copyTo'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)).replace('{versionId}', encodeURI(versionId)),
            method: 'POST',
            headers,
            body: copyToConfig,
        }, option);
    },

    /**
     * Copies backed-up OneDrive documents to another location in Microsoft OneDrive.
     * Copy OneDrive Documents
     */
    oneDriveDocumentCopyToDocumentsAction: ({ restoreSessionId, oneDriveId, restoreConfig }: OneDriveDocumentApiOneDriveDocumentCopyToDocumentsActionRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentCopyToDocumentsAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentCopyToDocumentsAction');
        throwIfNullOrUndefined(restoreConfig, 'restoreConfig', 'oneDriveDocumentCopyToDocumentsAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/copyTo'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'POST',
            headers,
            body: restoreConfig,
        }, option);
    },

    /**
     * Returns a collection of OneDrive documents to explore and restore.
     * Get OneDrive Documents
     */
    oneDriveDocumentGet: ({ restoreSessionId, oneDriveId, offset, limit, parentId, includeFolders }: OneDriveDocumentApiOneDriveDocumentGetRequest, option?: RequestOption): Observable<Optional<PageOfRESTItemComposed>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentGet');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentGet');
        throwIfNullOrUndefined(offset, 'offset', 'oneDriveDocumentGet');
        throwIfNullOrUndefined(limit, 'limit', 'oneDriveDocumentGet');

        const headers: HttpHeaders = {
        };

        const query: HttpQuery = { // required parameters are used directly since they are already checked by throwIfNullOrUndefined
            'offset': offset,
            'limit': limit,
        };

        if (parentId != null) { query['parentId'] = parentId; }
        if (includeFolders != null) { query['includeFolders'] = includeFolders; }

        return requestAuthenticated<PageOfRESTItemComposed>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'GET',
            headers,
            query,
        }, option);
    },

    /**
     * Returns a resource representation of a backed-up OneDrive document with the specified ID.
     * Get OneDrive Document
     */
    oneDriveDocumentGetById: ({ restoreSessionId, oneDriveId, documentId }: OneDriveDocumentApiOneDriveDocumentGetByIdRequest, option?: RequestOption): Observable<Optional<RESTOneDriveDocument>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentGetById');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentGetById');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentGetById');

        const headers: HttpHeaders = {
        };

        return requestAuthenticated<RESTOneDriveDocument>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'GET',
            headers,
        }, option);
    },

    /**
     * Returns a resource representation of a specific version of a backed-up OneDrive document with the specified ID.
     * Get Specific Version of OneDrive Document
     */
    oneDriveDocumentGetByIdByVersionId: ({ restoreSessionId, oneDriveId, documentId, versionId }: OneDriveDocumentApiOneDriveDocumentGetByIdByVersionIdRequest, option?: RequestOption): Observable<Optional<RESTOneDriveDocument>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentGetByIdByVersionId');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentGetByIdByVersionId');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentGetByIdByVersionId');
        throwIfNullOrUndefined(versionId, 'versionId', 'oneDriveDocumentGetByIdByVersionId');

        const headers: HttpHeaders = {
        };

        return requestAuthenticated<RESTOneDriveDocument>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions/{versionId}'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)).replace('{versionId}', encodeURI(versionId)),
            method: 'GET',
            headers,
        }, option);
    },

    /**
     * Returns a collection of versions of a backed-up OneDrive document with the specified ID.  When you get OneDrive document versions, the server returns information about previous versions of the document. To get the latest version, use either [Get OneDrive Document](#tag/OneDriveDocument/operation/OneDriveDocument_GetById) or [Get Specific Version of OneDrive Document](#tag/OneDriveDocument/operation/OneDriveDocument_GetByIdByVersionId). 
     * Get Previous Versions of OneDrive Document
     */
    oneDriveDocumentGetVersions: ({ restoreSessionId, oneDriveId, documentId, offset, limit }: OneDriveDocumentApiOneDriveDocumentGetVersionsRequest, option?: RequestOption): Observable<Optional<PageOfRESTOneDriveDocument>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentGetVersions');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentGetVersions');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentGetVersions');
        throwIfNullOrUndefined(offset, 'offset', 'oneDriveDocumentGetVersions');
        throwIfNullOrUndefined(limit, 'limit', 'oneDriveDocumentGetVersions');

        const headers: HttpHeaders = {
        };

        const query: HttpQuery = { // required parameters are used directly since they are already checked by throwIfNullOrUndefined
            'offset': offset,
            'limit': limit,
        };

        return requestAuthenticated<PageOfRESTOneDriveDocument>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'GET',
            headers,
            query,
        }, option);
    },

    /**
     * Restores backed-up OneDrive documents using Restore Portal. For more information about Restore Portal, see the [Data Restore Using Restore Portal](https://helpcenter.veeam.com/docs/vbo365/guide/ssp_restore.html?ver=80) section of the Veeam Backup for Microsoft 365 User Guide. <div class=\"note\"><strong>NOTE</strong> </br> To restore data using Restore Portal, you must create a restore session for a restore operator. For more information, see [Create Restore Session for Restore Operator](#tag/RestoreSession/operation/RestoreSession_OperatorExploreAction). </div> 
     * Restore OneDrive Documents by Restore Operator
     */
    oneDriveDocumentOperatorRestore: ({ restoreSessionId, oneDriveId, options }: OneDriveDocumentApiOneDriveDocumentOperatorRestoreRequest, option?: RequestOption): Observable<Optional<RESTOperatorRestoreSessionResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentOperatorRestore');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentOperatorRestore');
        throwIfNullOrUndefined(options, 'options', 'oneDriveDocumentOperatorRestore');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTOperatorRestoreSessionResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/operatorRestore'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'POST',
            headers,
            body: options,
        }, option);
    },

    /**
     * Restores a backed-up OneDrive document with the specified ID to its original location.
     * Restore OneDrive Document
     */
    oneDriveDocumentRestoreDocumentAction: ({ restoreSessionId, oneDriveId, documentId, restoreConfig }: OneDriveDocumentApiOneDriveDocumentRestoreDocumentActionRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentRestoreDocumentAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentRestoreDocumentAction');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentRestoreDocumentAction');
        throwIfNullOrUndefined(restoreConfig, 'restoreConfig', 'oneDriveDocumentRestoreDocumentAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/restore'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'POST',
            headers,
            body: restoreConfig,
        }, option);
    },

    /**
     * Restores a specific version of a backed-up OneDrive document to its original location.
     * Restore Version of OneDrive Document
     */
    oneDriveDocumentRestoreDocumentActionByVersionId: ({ restoreSessionId, oneDriveId, documentId, versionId, restoreConfig }: OneDriveDocumentApiOneDriveDocumentRestoreDocumentActionByVersionIdRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentRestoreDocumentActionByVersionId');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentRestoreDocumentActionByVersionId');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentRestoreDocumentActionByVersionId');
        throwIfNullOrUndefined(versionId, 'versionId', 'oneDriveDocumentRestoreDocumentActionByVersionId');
        throwIfNullOrUndefined(restoreConfig, 'restoreConfig', 'oneDriveDocumentRestoreDocumentActionByVersionId');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions/{versionId}/restore'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)).replace('{versionId}', encodeURI(versionId)),
            method: 'POST',
            headers,
            body: restoreConfig,
        }, option);
    },

    /**
     * Restores backed-up OneDrive documents to their original location.
     * Restore OneDrive Documents
     */
    oneDriveDocumentRestoreDocumentsAction: ({ restoreSessionId, oneDriveId, restoreConfig }: OneDriveDocumentApiOneDriveDocumentRestoreDocumentsActionRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentRestoreDocumentsAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentRestoreDocumentsAction');
        throwIfNullOrUndefined(restoreConfig, 'restoreConfig', 'oneDriveDocumentRestoreDocumentsAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/restore'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'POST',
            headers,
            body: restoreConfig,
        }, option);
    },

    /**
     * Saves a backed-up OneDrive document with the specified ID.  When you save a document, the request command places the document to a temporary folder on the Veeam Backup for Microsoft 365 server. After that, the document is transferred as application/octet-stream media to the client. To download, read or perform other actions with the octet-stream, use features of programming languages.  If downloading of the octet-stream was interrupted for some reason, you can send the request again and download the file from the temporary folder. 
     * Save OneDrive Document
     */
    oneDriveDocumentSaveDocumentAction: ({ restoreSessionId, oneDriveId, documentId, saveOptions }: OneDriveDocumentApiOneDriveDocumentSaveDocumentActionRequest, option?: RequestOption): Observable<Optional<object>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSaveDocumentAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSaveDocumentAction');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentSaveDocumentAction');
        throwIfNullOrUndefined(saveOptions, 'saveOptions', 'oneDriveDocumentSaveDocumentAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<object>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/save'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'POST',
            headers,
            body: saveOptions,
        }, option);
    },

    /**
     * Saves a specific version of a backed-up OneDrive document with the specified ID.  When you save a document, the request command places the document to a temporary folder on the Veeam Backup for Microsoft 365 server. After that, the document is transferred as application/octet-stream media to the client. To download, read or perform other actions with the octet-stream, use features of programming languages.  If downloading of the octet-stream was interrupted for some reason, you can send the request again and download the file from the temporary folder. 
     * Save Version of OneDrive Document
     */
    oneDriveDocumentSaveDocumentActionByVersionId: ({ restoreSessionId, oneDriveId, documentId, versionId, saveOptions }: OneDriveDocumentApiOneDriveDocumentSaveDocumentActionByVersionIdRequest, option?: RequestOption): Observable<Optional<object>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSaveDocumentActionByVersionId');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSaveDocumentActionByVersionId');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentSaveDocumentActionByVersionId');
        throwIfNullOrUndefined(versionId, 'versionId', 'oneDriveDocumentSaveDocumentActionByVersionId');
        throwIfNullOrUndefined(saveOptions, 'saveOptions', 'oneDriveDocumentSaveDocumentActionByVersionId');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<object>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions/{versionId}/save'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)).replace('{versionId}', encodeURI(versionId)),
            method: 'POST',
            headers,
            body: saveOptions,
        }, option);
    },

    /**
     * Saves backed-up OneDrive documents.  OneDrive documents are always saved in a ZIP archive. When you save backed-up OneDrive documents, the request command archives the documents and places the ZIP archive a temporary folder on the Veeam Backup for Microsoft 365 server. After that, the archive is transferred as application/octet-stream media to the client. To download, read or perform other actions with the octet-stream, use features of programming languages.  If downloading of the octet-stream was interrupted for some reason, you can send the request again and download the file from the temporary folder. 
     * Save OneDrive Documents
     */
    oneDriveDocumentSaveDocumentsAction: ({ restoreSessionId, oneDriveId, saveDocuments }: OneDriveDocumentApiOneDriveDocumentSaveDocumentsActionRequest, option?: RequestOption): Observable<Optional<object>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSaveDocumentsAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSaveDocumentsAction');
        throwIfNullOrUndefined(saveDocuments, 'saveDocuments', 'oneDriveDocumentSaveDocumentsAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<object>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/save'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'POST',
            headers,
            body: saveDocuments,
        }, option);
    },

    /**
     * Sends a backed-up OneDrive document with the specified ID as an attachment in an email message. <div class=\"note\"><strong>NOTE</strong> </br> To send items as attachments, you must specify the Veeam Explorer for Microsoft OneDrive for Business email settings. For more information, see [Edit Email Settings](#tag/VeodEmailSettings/operation/VeodEmailSettings_Update). </div> 
     * Send OneDrive Document
     */
    oneDriveDocumentSendDocumentAction: ({ restoreSessionId, oneDriveId, documentId, options }: OneDriveDocumentApiOneDriveDocumentSendDocumentActionRequest, option?: RequestOption): Observable<Optional<void>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSendDocumentAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSendDocumentAction');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentSendDocumentAction');
        throwIfNullOrUndefined(options, 'options', 'oneDriveDocumentSendDocumentAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<void>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/send'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)),
            method: 'POST',
            headers,
            body: options,
        }, option);
    },

    /**
     * Sends a specific version of a backed-up OneDrive document as an attachment in an email message. <div class=\"note\"><strong>NOTE</strong> </br> To send items as attachments, you must specify the Veeam Explorer for Microsoft OneDrive for Business email settings. For more information, see [Edit Email Settings](#tag/VeodEmailSettings/operation/VeodEmailSettings_Update). </div> 
     * Send Version of OneDrive Document
     */
    oneDriveDocumentSendDocumentActionByVersionId: ({ restoreSessionId, oneDriveId, documentId, versionId, options }: OneDriveDocumentApiOneDriveDocumentSendDocumentActionByVersionIdRequest, option?: RequestOption): Observable<Optional<void>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSendDocumentActionByVersionId');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSendDocumentActionByVersionId');
        throwIfNullOrUndefined(documentId, 'documentId', 'oneDriveDocumentSendDocumentActionByVersionId');
        throwIfNullOrUndefined(versionId, 'versionId', 'oneDriveDocumentSendDocumentActionByVersionId');
        throwIfNullOrUndefined(options, 'options', 'oneDriveDocumentSendDocumentActionByVersionId');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<void>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/{documentId}/Versions/{versionId}/send'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)).replace('{documentId}', encodeURI(documentId)).replace('{versionId}', encodeURI(versionId)),
            method: 'POST',
            headers,
            body: options,
        }, option);
    },

    /**
     * Sends backed-up OneDrive documents as attachments in an email message. <div class=\"note\"><strong>NOTE</strong> </br> To send items as attachments, you must specify the Veeam Explorer for Microsoft OneDrive for Business email settings. For more information, see [Edit Email Settings](#tag/VeodEmailSettings/operation/VeodEmailSettings_Update). </div> 
     * Send OneDrive Documents
     */
    oneDriveDocumentSendDocumentsAction: ({ restoreSessionId, oneDriveId, options }: OneDriveDocumentApiOneDriveDocumentSendDocumentsActionRequest, option?: RequestOption): Observable<Optional<void>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'oneDriveDocumentSendDocumentsAction');
        throwIfNullOrUndefined(oneDriveId, 'oneDriveId', 'oneDriveDocumentSendDocumentsAction');
        throwIfNullOrUndefined(options, 'options', 'oneDriveDocumentSendDocumentsAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<void>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/OneDrives/{oneDriveId}/Documents/send'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{oneDriveId}', encodeURI(oneDriveId)),
            method: 'POST',
            headers,
            body: options,
        }, option);
    },

})
